import axios from "axios"
import { useMutation } from "react-query"

const useResetPassword = () => {
  const { mutate, isLoading } = useMutation((variables) =>
    axios.post("https://staging.forgehub.com/api2/login/forgot", variables).then((res) => res.data),
  )

  return {
    resetPassword: mutate,
    isLoading,
  }
}

export default useResetPassword
